import groupCompanies from './group-companies';
import policies from './policies';

const modules = {
  groupCompanies,
  policies
};

export default {
  modules
};
